export function selectBotSettingsPage(cookieBotType, envelope) {
  const settings = envelope && envelope.settings;
  if (settings && settings.bot_type === "universal_v1") {
    return "universal";
  }
  if (cookieBotType === "renovation") {
    return "renovation";
  }
  if (cookieBotType !== "roofing") {
    return "real_estate";
  }
  if (settings && settings.bot_type === "roofing_v2") {
    return "roofing_v2";
  }
  if (!settings || settings.bot_type === "roofing_v1" || settings.bot_type === "roofing") {
    return "roofing_v1";
  }
  return "unsupported";
}

export function roofingSettingsGate({
  authToken,
  requestStatus,
  httpStatus,
  envelope,
  cookieBotType = "roofing",
}) {
  if (requestStatus === "loading") {
    return "loading";
  }
  if (!authToken || httpStatus === 401) {
    return "unauthenticated";
  }
  if (httpStatus === 403) {
    return "forbidden";
  }
  if (requestStatus === "error") {
    return "error";
  }
  return selectBotSettingsPage(cookieBotType, envelope);
}
